import { render } from "./datasrcManagerView.vue?vue&type=template&id=5d3138e0"
import script from "./datasrcManagerView.vue?vue&type=script&lang=js"
export * from "./datasrcManagerView.vue?vue&type=script&lang=js"

import "./datasrcManagerView.vue?vue&type=style&index=0&id=5d3138e0&lang=less"

import exportComponent from "E:\\Work\\GPTWeb\\licCode\\lic\\webviewer\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__